import { APICore } from './apiCore'

const api = new APICore()

function getTipos (params) {
  const baseUrl = '/tipo-incidencias'
  return api.get(baseUrl, params)
}

function getTipo (id) {
  const baseUrl = `/tipo-incidencias/${id}`
  return api.get(baseUrl, {})
}

function addTipo (params) {
  const baseUrl = '/tipo-incidencias'
  return api.create(baseUrl, params)
}

function updateTipo (params) {
  const baseUrl = '/tipo-incidencias'
  return api.update(baseUrl, params)
}

function deleteTipo (params) {
  const baseUrl = '/tipo-incidencias'
  return api.delete(baseUrl, params)
}

export { getTipos, getTipo, addTipo, updateTipo, deleteTipo }
